import immer from 'immer';
import type { ApolloCache } from '@apollo/client';
import { GetCollectionsForProject } from '@frameio/graphql-client/generated';

export function removeCollectionFromCache(
  cache: ApolloCache<any>,
  collectionId: string,
  projectId: string
) {
  cache.updateQuery(
    {
      query: GetCollectionsForProject,
      variables: { projectId },
    },
    (data) =>
      immer(data, (draft) => {
        const collections = draft?.account?.project?.collections;
        if (collections?.nodes) {
          collections.nodes = collections.nodes.filter(
            (c) => c.id !== collectionId
          );
        }
      })
  );
}
